import { render, staticRenderFns } from "./GiftingReminders.vue?vue&type=template&id=00346418&scoped=true&"
import script from "./GiftingReminders.vue?vue&type=script&lang=js&"
export * from "./GiftingReminders.vue?vue&type=script&lang=js&"
import style0 from "./GiftingReminders.vue?vue&type=style&index=0&id=00346418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00346418",
  null
  
)

export default component.exports